export default __webpack_public_path__ + "static/media/check2.3f659e2c.svg";